import React, { useState } from "react";
import PropTypes from "prop-types";

const Tabs = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div className="tabs">
            {tabs.length > 1 && (
                <nav className="tabs__navigation">
                    {tabs.map((tab, index) => {
                        const isActive = index === activeTab;
                        const classes = isActive
                            ? "tabs__navigation__title active"
                            : "tabs__navigation__title";
                        return (
                            <div
                                key={`tab-${index}`}
                                className={classes}
                                onClick={() => {
                                    setActiveTab(index);
                                }}
                            >
                                {tab.icon}
                                <p>{tab.title}</p>
                            </div>
                        );
                    })}
                </nav>
            )}

            <div className="tabs__content">{tabs[activeTab].content}</div>
        </div>
    );
};

const tabType = {
    title: PropTypes.string,
    icon: PropTypes.element,
    content: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape(tabType)),
};

export default Tabs;
